<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">Grup İşlemler</h4>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Cihazlar</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Cihaz Anagrup</label>
                <select @change="onChange($event)" v-model="newPost.grupid"  class="form-control">
                  <option value="0">Cihaz Grubunu seç</option>
                  <option v-for="option in grup" :value="option.id" :key="option.id">{{ option.alias }}
                  </option>
                </select>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Kodu</label>
                <input placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.kodu"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Alias</label>
                <input @keyup="this.$helper.tabloarama" id="arama" placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.alias"/>  
              </div> 
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Ağrlık (kg.)</label>
                <input placeholder="Kilogram" type="text" class="form-control" v-model="newPost.agirlik"/>
              </div>
            </div>
            <div class="row mt-3">
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Genişlik (cm.)</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.genislik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Derinlik (cm.)</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.derinlik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Yükseklik (cm.)</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.yukseklik"/>
              </div>
               <div class="col-lg-3 col-12 mt-4 p-2">
                <button @click="sendNewPost()" class="btn btn-danger w-100">{{progres.mesaj}}</button>
              </div>
            </div>

          </div>
        </div>
      </div>
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <input type="file" @change="previewFiles">
                  <div v-if="errors && errors.length" class="container-fluid text-center">
                    <div class="loading dashtext-2">Veritabanı Hatası</div>
                     <ul>
                       <li>
                         
                       </li>
                        <li v-for="(error, index) of errors" :key="index">
                          {{ index + 1 }} - {{ error.message }}
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-3">
                <img :src="$request.domain+newPost.img" class="img-fluid">
              </div>
            </div>            
    </div>
  </section>
  <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

  export default {  
    created() {
      this.progres.inprogres=true
      this.yetki();
      
    },
    data() {
      return {
        progres : {
        mesaj:'Bekleyiniz',
        inprogres:true
      },
        posts: [],
        errors: [],
        grup:[],
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        //table:this.$route.params.table,
        newPost:
              {
                firma : this.$request.ayar().firmaid,
                kodu :'',
                alias:'',
                grupid:0,
                genislik:0,
                derinlik:0,
                yukseklik:0,
                agirlik:0,
                id:this.$route.params.id,
                img:''
             }
      };
    },
    methods: {
          yetki(){ 
          if (this.$helper.sayfayetki(516410)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){this.cihazgrup(this.getir);}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        
        },

        cihazgrup(callback){
            this.$request.get("cihazgrup/"+this.newPost.firma)
            .then(res => {this.grup = res.results
             this.progres.mesaj="Kayıt Düzenle";
            })
            callback()
        },
        getir(){
         this.$request.get("/altgrup2/"+this.newPost.firma+"/"+this.newPost.id)
            .then(
              res => {
                this.newPost.grupid = res.results[0].gid
                this.newPost.kodu = res.results[0].mkod
                this.newPost.alias = res.results[0].malias
                this.newPost.genislik = res.results[0].genislik
                this.newPost.derinlik = res.results[0].derinlik
                this.newPost.yukseklik = res.results[0].yukseklik
                this.newPost.agirlik = res.results[0].agirlik
                this.newPost.img = res.results[0].foto
              this.progres.inprogres=false;
            })
        },

      sendNewPost() {
        if (this.newPost.kodu && this.newPost.alias && this.newPost.grupid>0){
          this.progres.inProgress = true
            this.$request.post("/altgrupduzenleme/",this.newPost )
            .then( res =>{
             this.$swal("Kayıt Düzenleme Başarılı")
             this.getir()
            }
          )
        .catch(err => this.$swal(err))
        this.progres.inProgress = false;
        }
        else{
          this.$swal("Girdileri Kontrol Et")
        }
      },
previewFiles(event) {
  let data = {image:event.target.files}
  this.$request.post("upload",data)
  .then(res => {
    if (res.success){
      this.$swal("Foto Yükleme Başarılı")
      this.newPost.img = res.url
    }
    
  })
  //.catch(err => {alert(err)})
    //  console.log(event.target.files);
   }      
    },  
  };
</script>
<style scoped>
.highlight {
  background:lightslategray;
  color: white;
}
li{list-style: none; display:inline-block}
</style>


// WEBPACK FOOTER //
// src/views/cihaz/duzenaltgrup.vue